module.exports = __webpack_public_path__ + "static/media/proj2_img2.a1223f85.jpg";